export default __webpack_public_path__ + "static/media/hidergardVonBigen.5fd7b6f7.jpg";